define('view/controller/booking/result/BookingCancellationDialogView',['require','lib/view/LayoutView','lib/view/FormView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var FormView = require('lib/view/FormView');

    /**
     * Booking cancellation dialog view
     *
     * @class BookingCancellationDialogView
     */
    return FormView.extend({

        template: '#booking_cancellation_dialog',

        ui: {
            cancelBtn: '#sb_cancellation_cancel',
            confirmBtn: '#sb_cancellation_confirm',
            allRecurringCheck: '#is_all_recurring',
            allGroupCheck: '#is_all_group',
            data : ':input'
        },
        events: {
            'click @ui.confirmBtn': 'onConfirmBtnClick', 
            'change @ui.allGroupCheck': 'onAllGroupChange',
            'change @ui.allRecurringCheck': 'onAllRecurringChange'
        },

        modelEvents: {
            'sync': 'render',
            'change': 'render',
            'invalid' : 'render'
        },

        serializeData: function () {
            var res = this._serializeData();
            
            res.batch_type = this.getOption('bookingModel').get('batch_type');
            res.apply_to_batch = this._applyToBatch;
            
            return res;
        },

        onConfirmBtnClick: function () {
            this.ui.confirmBtn.attr({
                disabled: true
            });
            
            this.model.set(this._getData(this.ui.data), {silent:true});

            if (this.model.isValid()) {
                this.triggerMethod('confirm', {
                    model: this.getOption('bookingModel'),
                    region: this._parent,
                    reason : this.model.get('reason'),
                    batch: this._applyToBatch
                });
            } else {
                console.warn(this.model);
            }
        },
        
        onAllGroupChange: function () {
            this._applyToBatch = this.ui.allGroupCheck.is(':checked') ? 'group' : undefined;
        },
        
        onAllRecurringChange: function () {
            this._applyToBatch = this.ui.allRecurringCheck.is(':checked') ? 'recurring' : undefined;
        },

        onDomRefresh: function() {
            Backbone.Wreqr.radio.vent.trigger('module', 'shown', {
                'module': 'booking_cancellation_dialog'
            });
        }

    });

});
